import React, { useState } from "react"

import SanityBlockContent from "@sanity/block-content-to-react"
import { GatsbyImage } from "gatsby-plugin-image"
export default function Hero({ property, className }) {
  const [readMore, setReadMore] = useState(true)

  const More = () => {
    setReadMore(readMore => !readMore)
  }

  return (
    <div className="w-full mx-auto">
      <main className="container mx-auto grid justify-items-stretch items-stretch h-auto px-2 lg:px-8">
        <div
          className={
            "col-start-1 row-start-1 relative z-10 self-center h-auto lg:h-[80vh] flex items-center justify-center " +
            className
          }
        >
          {property.subTitle ? (
            <div className="grid gap-2 py-24 lg:py-0">
              <p className="font-normal uppercase tracking-[0.8em] text-sm text-white font-property text-center pb-[30px] filter drop-shadow">
                {property.title || property.name}
              </p>
              {property.subTitle && (
                <h1 className=" text-white max-w-xl mx-auto text-center filter drop-shadow">
                  {property.subTitle}
                </h1>
              )}

              <div
                className={
                  readMore
                    ? "text-center text-[11px] md:text-[12px] font-light filter drop-shadow text-gray-300 leading-4 md:leading-5 pt-8 max-w-2xl mx-auto w-11/12 line-clamp-3"
                    : "text-center text-[11px] md:text-[12px] font-light filter drop-shadow text-gray-300 leading-4 md:leading-5 pt-8 max-w-2xl mx-auto w-11/12"
                }
              >
                {property._rawDescription && (
                  <SanityBlockContent blocks={property._rawDescription} />
                )}
                {property._rawContent && (
                  <SanityBlockContent blocks={property._rawContent} />
                )}
              </div>

              <div className="max-w-2xl mx-auto w-11/12 -mt-2 flex justify-center">
                <button
                  onClick={More}
                  className="text-white uppercase text-[11px] md:text-[12px] font-bold  outline-none focus:outline-none"
                >
                  read {readMore ? "more" : "less"}
                </button>
              </div>
            </div>
          ) : (
            <div className="grid gap-2 py-24 lg:py-0">
              <h1 className=" text-white max-w-xl mx-auto text-center filter drop-shadow">
                {property.title || property.name}
              </h1>

              <div
                className={
                  readMore
                    ? "text-center text-[11px] md:text-[12px] font-light filter drop-shadow text-gray-300 leading-4 md:leading-5 pt-8 max-w-2xl mx-auto w-11/12 line-clamp-3"
                    : "text-center text-[11px] md:text-[12px] font-light filter drop-shadow text-gray-300 leading-4 md:leading-5 pt-8 max-w-2xl mx-auto w-11/12"
                }
              >
                {property._rawDescription && (
                  <SanityBlockContent blocks={property._rawDescription} />
                )}
                {property._rawContent && (
                  <SanityBlockContent blocks={property._rawContent} />
                )}
              </div>

              <div className="max-w-2xl mx-auto w-11/12 -mt-2 flex justify-center">
                <button
                  onClick={More}
                  className="text-white uppercase text-[11px] md:text-[12px] font-bold  outline-none focus:outline-none"
                >
                  read {readMore ? "more" : "less"}
                </button>
              </div>
            </div>
          )}
        </div>
        <div className="col-start-1 row-start-1 relative z-0 self-auto ">
          {property.headerImage?.asset ? (
            <GatsbyImage
              image={
                property.headerImage?.asset &&
                property.headerImage?.asset.gatsbyImageData
              }
              // alt={property.name}
              alt={property.name}
              className={
                readMore
                  ? "w-full object-cover h-[85vh] lg:h-[80vh]"
                  : "w-full object-cover h-full lg:h-[80vh]"
              }
            />
          ) : (
            <div className="bg-gray-500 h-full lg:h-[80vh]" />
          )}
        </div>
      </main>
    </div>
  )
}
